var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2857 9.42857C18.9166 9.42857 19.4286 8.91657 19.4286 8.28571C19.4286 7.65486 18.9166 7.14286 18.2857 7.14286H5.14286C4.512 7.14286 4 7.65486 4 8.28571C4 8.91657 4.512 9.42857 5.14286 9.42857H18.2857ZM22.8571 0H1.14286C0.512 0 0 0.512 0 1.14286C0 1.77371 0.512 2.28571 1.14286 2.28571H22.8571C23.488 2.28571 24 1.77371 24 1.14286C24 0.512 23.488 0 22.8571 0ZM20 14.2857H4C3.36914 14.2857 2.85714 14.7977 2.85714 15.4286C2.85714 16.0594 3.36914 16.5714 4 16.5714H20C20.6309 16.5714 21.1429 16.0594 21.1429 15.4286C21.1429 14.7977 20.6309 14.2857 20 14.2857Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align_center.0cd539abc47401de19b0dc9eec7bef9a.svg";
export { ForwardRef as ReactComponent };